import type { Rank, Suit } from "./types.js";

export const RANKS: readonly Rank[] = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13];
export const SUITS: readonly Suit[] = ["hearts", "diamonds", "clubs", "spades"];

export const RACK_SIZE = 4;
export const ROOM_CODE_LENGTH = 6;
export const MAX_PLAYER_NAME_LENGTH = 18;

export const RANK_LABELS: Record<Rank, string> = {
  1: "A",
  2: "2",
  3: "3",
  4: "4",
  5: "5",
  6: "6",
  7: "7",
  8: "8",
  9: "9",
  10: "10",
  11: "J",
  12: "Q",
  13: "K",
};

export const RANK_NAMES: Record<Rank, string> = {
  1: "as",
  2: "dos",
  3: "tres",
  4: "cuatro",
  5: "cinco",
  6: "seis",
  7: "siete",
  8: "ocho",
  9: "nueve",
  10: "diez",
  11: "jota",
  12: "reina",
  13: "rey",
};

export const SUIT_NAMES: Record<Suit, string> = {
  hearts: "corazones",
  diamonds: "diamantes",
  clubs: "tréboles",
  spades: "picas",
};
